export default class CustomerEmailAddress {
  constructor (customerId, type) {
    this.actions = {
      create: 'createCustomerEmailAddress',
      update: 'updateCustomerEmailAddress',
      remove: 'deleteCustomerEmailAddress'
    }

    this.requestData = { customerId, type }
    this.name = 'emailAddress'
  }

  isNew (data) {
    return data.id === null || data.id === undefined
  }

  isEmpty (data) {
    return data.email === '' || data.email === null || data.email === undefined
  }

  static empty () {
    return { id: null, email: '', label: '' }
  }

  static parse (data) {
    return {
      id: data.id,
      email: data.email,
      label: data.label || ''
    }
  }

  static parseResponseData (response) {
    let email = response.emailAddresses

    response.emailAddresses = (email && email.data && email.data.length > 0)
      ? email.data.map(CustomerEmailAddress.parse)
      : []

    return response
  }
}
